import React,{Component} from 'react';
import { firebaseAuth,ref } from '../config/constants'

import Sidebar from './inc/Sidebar';
import Header from './inc/Header';
import Title from './inc/Title';
import Footer from './inc/Footer';


class EditDimension extends Component{
    constructor(){
        super();
        
        this.handleChange = this.handleChange.bind(this);
        this.updateDimension = this.updateDimension.bind(this);
        this.cancelUpdate = this.cancelUpdate.bind(this);

        this.state ={
         userId : "",
         user : {},
         editDimension : {}
        
        }
    }

    componentWillMount() {

        this.listener = firebaseAuth().onAuthStateChanged(user=>{
            if (user){
                var db = ref.child("users").child(user.uid);
                db.on("value",function(data){

                    this.setState({
                    userId:data.key,
                    user:data.val()
                    });

                }.bind(this));
                
                var dbEdit = ref.child("BendedPrice").child(this.props.match.params.did);
                dbEdit.on("value",function(data){             
                    this.setState({
                        editDimension : data.val()
                    });

                }.bind(this));
            }else{
                this.props.history.push("/");
            }
        });

    } 
  

    componentWillUnmount(){
      this.listener()
    }

    updateDimension(e){
        e.preventDefault();

        const updatedDimension=this.state.editDimension
        ref.child("BendedPrice").child(this.props.match.params.did).update(updatedDimension).then(()=>{
        alert("Dimension updated successfully")
        this.props.history.push("/dimension");
        });
    }

    handleChange(e){
        let editDimension = this.state.editDimension;
        let update ={
            ...editDimension,
            [e.target.name]:e.target.value
        } 
        this.setState({editDimension:update})       
    }

    cancelUpdate(){
        if (window.confirm("Do you want to cancel updating this dimension?") === true){
            this.props.history.push("/dimension");
        }else{
            alert("make updates to the dimension")
        }
    }  

    render() {
       
        return (
            <div id="page-wrapper">
                <div id="page-container" className="sidebar-partial sidebar-visible-lg sidebar-no-animations">
                    <Sidebar  role={this.state.user.role} />
                    <div id="main-container">
                        <Header />
                        <div id="page-content">
                            <Title title="Update Dimension" />
                            <div className="block">
                                <div className="block-title">
                                    <h2><i className="fa fa-pencil"></i> <strong>Product</strong> Information</h2>
                                </div>
                                <form className="form-horizontal form-bordered" onSubmit={this.updateDimension}>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Dimension</label>
                                        <div className="col-md-4">
                                            <input className="form-control" name="dimension" type="text" required value={this.state.editDimension.dimension} onChange={this.handleChange}/>
                                        </div>
                                    </div>                                    

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.4MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" name="price_4MM" type="text" required value={this.state.editDimension.price_4MM} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.5MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" name="price_5MM" type="text" required value={this.state.editDimension.price_5MM} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.6MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" name="price_6MM" type="text" required value={this.state.editDimension.price_6MM} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group">
                                        <label className="col-md-3 control-label" htmlFor="product-id">Product Price (.8MM)</label>
                                        <div className="col-md-2">
                                            <div className="input-group">
                                                <div className="input-group-addon"><i className="fa fa-rub"></i></div>
                                                <input className="form-control" name="price_8MM" type="text" required value={this.state.editDimension.price_8MM} onChange={this.handleChange}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="form-group form-actions">
                                        <div className="col-md-9 col-md-offset-3">
                                            <button type="submit" className="btn btn-sm btn-primary" ><i className="fa fa-floppy-o"></i> Update Dimension</button> 
                                            <button type="reset" className="btn btn-sm btn-warning" onClick={this.cancelUpdate}><i className="fa fa-repeat"></i> Reset</button>
                                        </div>
                                    </div>

                                </form>
                            </div>
                        </div>
                        <Footer />
                    </div>
                </div>
            </div>

        );
    }
}

export default  EditDimension;



// WEBPACK FOOTER //
// ./src/components/EditDimension.js